/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type Currency = "%future added value" | "%future added value" | "%future added value" | "%future added value" | "%future added value" | "%future added value" | "%future added value" | "%future added value" | "%future added value" | "%future added value" | "%future added value" | "%future added value" | "%future added value" | "%future added value" | "%future added value" | "%future added value" | "%future added value" | "%future added value" | "%future added value" | "%future added value" | "%future added value" | "%future added value" | "%future added value" | "%future added value" | "%future added value" | "%future added value" | "%future added value" | "%future added value" | "%future added value" | "%future added value" | "%future added value" | "%future added value" | "%future added value" | "%future added value" | "%future added value" | "%future added value" | "%future added value" | "%future added value" | "%future added value" | "%future added value" | "%future added value" | "%future added value" | "%future added value" | "%future added value" | "%future added value" | "%future added value" | "AUD" | "CAD" | "CHF" | "EUR" | "GBP" | "JPY" | "MXN" | "USD" | "%future added value";
export type RegionType = "CUSTOM" | "ITEM_LOCATION" | "LOCAL" | "NET_PRICE_REQUIREMENT" | "SHIPMENT_QUOTE_STATIC" | "TAX_NEXUS_V2" | "TRADE_FIRM_REGION" | "%future added value";
export type PdpSharedShippingInfo_shipmentQuote = {
    readonly handlingTimeDisplay: string | null;
    readonly totalAmount: {
        readonly currency: Currency | null;
        readonly amount: number | null;
        readonly convertedAmountList: ReadonlyArray<{
            readonly currency: Currency | null;
            readonly amount: number | null;
        } | null> | null;
    } | null;
    readonly buyerSubTotalAmount: {
        readonly convertedAmountList: ReadonlyArray<{
            readonly currency: Currency | null;
            readonly amount: number | null;
        } | null> | null;
    } | null;
    readonly buyerServiceMethodDisplay: string | null;
    readonly serviceMethod: {
        readonly serviceMethodType: string | null;
        readonly region: {
            readonly apiType: string | null;
            readonly code: string | null;
            readonly regionName: string | null;
            readonly regionType: RegionType | null;
        } | null;
    } | null;
    readonly " $refType": "PdpSharedShippingInfo_shipmentQuote";
};
export type PdpSharedShippingInfo_shipmentQuote$data = PdpSharedShippingInfo_shipmentQuote;
export type PdpSharedShippingInfo_shipmentQuote$key = {
    readonly " $data"?: PdpSharedShippingInfo_shipmentQuote$data;
    readonly " $fragmentRefs": FragmentRefs<"PdpSharedShippingInfo_shipmentQuote">;
};



const node: ReaderFragment = (function(){
var v0 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "currency",
  "args": null,
  "storageKey": null
},
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "amount",
  "args": null,
  "storageKey": null
},
v2 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "convertedAmountList",
  "storageKey": null,
  "args": null,
  "concreteType": "ConvertedAmountList",
  "plural": true,
  "selections": [
    (v0/*: any*/),
    (v1/*: any*/)
  ]
};
return {
  "kind": "Fragment",
  "name": "PdpSharedShippingInfo_shipmentQuote",
  "type": "ShipmentQuote",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "handlingTimeDisplay",
      "args": [
        {
          "kind": "Literal",
          "name": "displayShort",
          "value": true
        }
      ],
      "storageKey": "handlingTimeDisplay(displayShort:true)"
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "totalAmount",
      "storageKey": null,
      "args": null,
      "concreteType": "FinancialAmount",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        (v1/*: any*/),
        (v2/*: any*/)
      ]
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "buyerSubTotalAmount",
      "storageKey": null,
      "args": null,
      "concreteType": "FinancialAmount",
      "plural": false,
      "selections": [
        (v2/*: any*/)
      ]
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "buyerServiceMethodDisplay",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "serviceMethod",
      "storageKey": null,
      "args": null,
      "concreteType": "ShipmentServiceMethod",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "serviceMethodType",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "region",
          "storageKey": null,
          "args": null,
          "concreteType": "Region",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "apiType",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "code",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "regionName",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "regionType",
              "args": null,
              "storageKey": null
            }
          ]
        }
      ]
    }
  ]
};
})();
(node as any).hash = '01e45fea6240d3b6fdf0a6cfd1b328be';
export default node;
